<br>
<p-panel>
<!--   <p *ngIf="!showPhoto">Pulsa sobre la pantalla para hacer una captura</p> -->
 <!--  <div *ngIf="!showPhoto" class="d-flex justify-content-center">
    <div>
      <video autoplay style="height: 60vh; width: 80vw;" id="player"></video>
    </div>
  
  </div> -->
  <webcam 
  [trigger]="triggerObservable"
  (imageCapture)="handleImage($event)"
  (initError)="handleInitError($event)"></webcam>
<!--   <p *ngIf="showPhoto">Volver a la camara, pulsa sobre la pantalla</p> -->
  <div *ngIf="showPhoto" class="d-flex justify-content-center">
    <div style="max-height: 600px; max-width: 800px;">
      <img style="max-height: 60vh; max-width: 80vw;" (click)="triggerSnapshot()" id="imageTag">
    </div>
  </div>
  <br>
  <div class="d-flex justify-content-center">
     <button  class="btn btn-dark mx-2" (click)="closeDialog()">
      Cancelar
    </button>
    <button [disabled]="saveStatus" class="btn btn-primary mx-2" (click)="triggerSnapshot();">
      {{saveStatus || 'Realizar foto'}}
    </button>
  </div>
  <br>
</p-panel>
<br>
